import React from 'react';
import classnames from 'classnames';
import { PapiUser } from '@wix/da-papi-types';
import { useTranslation } from 'react-i18next';

import GhostButton from '@wix/da-ds/pkg/Buttons/GhostButton';
import Timestamp from '@wix/da-shared-react/pkg/Timestamp';

import { BulletItem } from '@wix/da-shared-react/pkg/Bullets';
import CalendarIcon from '@wix/da-ds/pkg/Icons/Calendar';
import EyeIcon from '@wix/da-ds/pkg/Icons/Eye';
import Eye2Icon from '@wix/da-ds/pkg/Icons/Eye2';

import s from './GroupAbout.scss';

export interface Props {
  className?: string;

  // module data
  title?: string;
  tagline?: string;
  foundationTs?: number;
  description?: string;

  // redux data
  profileOwnerUser: PapiUser;
  isOwner: boolean;
  watchers: number;
  pageviews: number;
  members: number;
  isMember: boolean;
  isAdmin: boolean;

  // redux actions
  messageAdmins: (group: PapiUser) => void;
  requestToJoin: (group: PapiUser) => void;
  inviteToGroup: (group: PapiUser) => void;
}

const GroupAbout: React.FC<Props> = ({
  className,

  description,
  foundationTs,

  profileOwnerUser,
  watchers,
  pageviews,
  members,
  isMember,
  isAdmin,

  messageAdmins,
  requestToJoin,
  inviteToGroup,
}) => {
  const { t } = useTranslation();
  return (
    <div className={classnames(s['root'], className)}>
      {description && <div className={s['description']}>{description}</div>}
      {foundationTs && (
        <div>
          <BulletItem bullet={<CalendarIcon disableDefaultColors />}>
            Founded:{' '}
            <Timestamp timestamp={new Date(foundationTs).toISOString()} />
          </BulletItem>
        </div>
      )}
      <div className={s['row']}>
        <BulletItem bullet={<EyeIcon disableDefaultColors />}>
          {members} Members
        </BulletItem>
        <BulletItem bullet={<EyeIcon disableDefaultColors />}>
          {watchers} Watchers
        </BulletItem>
        <BulletItem bullet={<Eye2Icon disableDefaultColors />}>
          {pageviews} Pageviews
        </BulletItem>
      </div>
      <div className={s['row']}>
        {isAdmin && (
          <GhostButton
            size="large"
            variant="main"
            onClick={() => inviteToGroup(profileOwnerUser)}
          >
            {t('widgets.group_about.view.button.invite')}
          </GhostButton>
        )}
        {!isAdmin && !isMember && (
          <GhostButton
            size="large"
            variant="main"
            onClick={() => requestToJoin(profileOwnerUser)}
          >
            {t('widgets.group_about.view.button.join')}
          </GhostButton>
        )}
        <GhostButton
          size="large"
          variant="main"
          onClick={() => messageAdmins(profileOwnerUser)}
        >
          {t('widgets.group_about.view.button.messageAdmins')}
        </GhostButton>
      </div>
    </div>
  );
};

GroupAbout.displayName = 'GroupAbout';

export default GroupAbout;
